import { SubmitHandler, useForm } from 'react-hook-form'

import { TrashIcon } from '@heroicons/react/24/outline'

import { formatCurrency, formatDate } from '../../../../../utils/helpers'
import { translatePaymetMethods } from '../../../../../utils/translate'

interface Props {
  close: () => void
  action: (_id: string) => void
  data: {
    id: string
    amount: number
    codeCurrency: string
    paymentWay: string
    createdAt: string
    operationNumber?: string
    observations?: string
  }
}
export const EditPay = ({ close, action, data }: Props) => {
  // Hooks
  const { handleSubmit } = useForm()

  const onSubmit: SubmitHandler<Record<string, unknown>> = () => {
    action(data.id)
    close()
  }

  return (
    <>
      <form className="px-8" onSubmit={handleSubmit(onSubmit)}>
        <div className="">
          {/* payments */}
          <div className="flex flex-col items-start gap-2 pt-2">
            <div className="flex w-full justify-end">
              <button type="submit">
                <TrashIcon className="w-7 cursor-pointer text-red-500" />
              </button>
            </div>
            <>
              <div className="flex flex-col gap-y-3">
                <h3 className="flex gap-x-2 font-semibold">
                  Monto:
                  <span className="font-normal">
                    {formatCurrency(data.amount, data.codeCurrency)}
                  </span>
                </h3>

                <h3 className="flex gap-x-2 font-semibold">
                  Método de pago:
                  <span className="font-normal">
                    {translatePaymetMethods(data.paymentWay)}
                  </span>
                </h3>
                <h3 className="flex gap-x-2 font-semibold">
                  Fecha de pago:
                  <span className="font-normal">
                    {formatDate(data.createdAt)}
                  </span>
                </h3>
                {data.operationNumber && (
                  <h3 className="flex gap-x-2 font-semibold">
                    Registro de caja:
                    <span className="font-normal">{data.operationNumber}</span>
                  </h3>
                )}
                {data.observations && (
                  <h3 className="flex flex-col gap-x-2 font-semibold">
                    Observaciones:
                    <span className="font-normal text-slate-500 opacity-80">
                      {data.observations}
                    </span>
                  </h3>
                )}
              </div>
            </>
          </div>
          <footer className="mt-5 flex w-full gap-x-3">
            {/* <Button
              name="Cancelar"
              color="white"
              textColor="blue-800"
              outline
              type="button"
              action={() => close()}
              full
            />

            <Button
              name="Editar"
              color="indigo-700"
              type="submit"
              //action={onSubmit}
              full
            /> */}
          </footer>
        </div>
      </form>
    </>
  )
}
